// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1cnyG","topBottomGutter":"Layout_topBottomGutter__1lBIF"};